import React from 'react';
import { connect } from "react-redux";
import { pushItem, cartIsLoading } from "../../stores/cartActions.js";
import { setTimeout } from 'timers';
import { Routing } from "../shared/routing.js";
import { Localize } from "../shared/localize.js";
import { Info } from "../shared/info.js";
import { trackThis } from "../cart/conversion-tracking.js";

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps, cart: state.cart
  };
};

const mapDispatchToProps = dispatch => {
  return {
    pushItem: item => dispatch(pushItem(item)),
    cartIsLoading: isLoading => dispatch(cartIsLoading(isLoading))
  };
};

class ConnectedAddToCartButton extends React.Component {
  constructor(props) {
    super(props);
    console.log("##ConnectedAddToCartButton",props)
    this.state = {
      target: props.target || "tire",

      isRedirecting: false
    };
  };

  onClick = (e) => {
    var { kitresult } = this.props;
    var payload = null;
    //var updated = null;
    switch (this.state.target) {
      case "kit":
        if (this.props.kitresult) {
          payload = { ...this.props.tireresult };
        } else if (window.global_data) {
          const kitToBuy = window.global_data;
          const car = kitToBuy.Car;
          const TPMS = kitToBuy.Wheel.Diameters.some(d => d.TPMS_id);
          var TPMS_id = null;
          if (TPMS) {
            TPMS_id = kitToBuy.Wheel.Diameters.map(d => d.TPMS_id)[0];
          }
          payload = {
            segment: "kit",
            Car: kitToBuy.Car,
            wheelid: kitToBuy.Wheel.wheelid,
            Brand: kitToBuy.Wheel.Brand,
            Model: kitToBuy.Wheel.Model,
            Holes: kitToBuy.Wheel.Holes,
            Color: kitToBuy.Wheel.Color,
            Diameter: kitToBuy.Diameter,
            //server side will recalculate BestPrice
            //but we should warn the user somehow the price changed
            BestPrice: kitToBuy.Wheel.BestPrice,

            brandid: kitToBuy.Tire.BrandID,
            cai: kitToBuy.Tire.Cai,
            uniquetireid: kitToBuy.Tire.UniqueTyreId,
            distributorid: kitToBuy.Tire.DistributorId,

            TPMS: TPMS,
            TPMS_id: TPMS_id,

            quantity: 4,
            Quantity: 4,//for wheel push deserialization, we need to rename the field in the c# class
          };
          kitresult = {
            description: `${car.ManufacturerName} ${car.ModelName} ${car.Year} ${car.ExtChassis} ${car.ExtModelType}`,
            brand: `${kitToBuy.Wheel.Brand} + ${kitToBuy.Tire.Brand}`
          };
        }
        //updated = this.props.pushItem(payload).then(() => {
        //  this.setState({ isRedirecting: true });
        //});
        break;
      case "tire":
        payload = { ...this.props.tireresult};
        //updated = this.props.pushItem(payload).then(() => {
        //  this.setState({ isRedirecting: true });
        //});
        break;
      case "spare":
        payload = {
          ...this.props.spareresult, car: { ...this.props.car }, year: this.props.year
        };
        //updated = this.props.pushItem(payload).then(() => {
        //  this.setState({ isRedirecting: true });
        //});
        break;
      case "wheel":
        payload = {
          ...this.props.wheelresult, car: { ...this.props.car }, year: this.props.year
        };
        //updated = this.props.pushItem(payload).then(() => {
        //  this.setState({ isRedirecting: true });
        //});
        break;
    }

    if (payload) {
      this.props.pushItem(payload).then(() => {
        this.props.cartIsLoading(true);

        console.log("!!finished-pushing-" + this.state.target);
        this.setState({ isRedirecting: true });
        trackThis({
          target: this.state.target,
          cartid: this.props.cart.cartid,
          tireresult: this.props.tireresult,
          wheelresult: this.props.wheelresult,
          spareresult: this.props.spareresult,
          kitresult: kitresult
        }).then((d) => {
          console.log("google goal tracking", d);
          //we must wait 250ms because redux state to localstorage is debounced for 250ms
          setTimeout(() => {
            console.log("redirect now", d);
            window.location.href = "/" + Routing.R("cart");
            this.setState({ isRedirecting: false });
            this.props.cartIsLoading(false);
          }, 250);
        });
      });
    }
  }

  render() {
    var ret = null;
    var text = this.props.text || Localize.L("Aggiungi al carrello");
    var style = this.props.style || "btn-big";

    //if (this.props.cart.isLoading) {
    //  text = <span><i className="fa fa-cog fa-spin fa-fw"></i> wait</span>;
    //} else if (this.state.isRedirecting) {
    //  text = <span><i className="fa fa-cog fa-spin fa-fw"></i> wait</span>;
    //}

    ret = (
      <span>
        <meta name="hash" content={this.props.hash}></meta>
        <meta name="criterialabel" content={this.props.criterialabel}></meta>
        <button type="button"
          className={"btn btn-danger btn-danger-glossy " + style + " " + (this.props.cart.isLoading || this.state.isRedirecting ? "disabled" : "")}
          style={{ minWidth: 76, fontSize: "20px"}}
          disabled={this.props.cart.isLoading || this.state.isRedirecting}
          data-cai={this.props.tireresult ? this.props.tireresult.cai : null}
          data-hash={this.props.hash}
          data-criterialabel={this.props.criterialabel}
          onClick={(e) => this.onClick(e)}>
          {text}
          </button>
        </span>
    );

    return ret;
  }
}

const AddToCartButton = connect(mapStateToProps, mapDispatchToProps)(ConnectedAddToCartButton);
export { AddToCartButton }
